import { render, staticRenderFns } from "./LoadProductList.vue?vue&type=template&id=5809ffe5&"
import script from "./LoadProductList.vue?vue&type=script&lang=js&"
export * from "./LoadProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LoadProductList.vue"
export default component.exports